import { Link } from 'react-router-dom';
import './../DetailsPageBanner.scss'
import SvgIcon from '@Components/icons/SvgIcon';
const Breadcrumb = ({ Headings }: any) => {
    return (
                <div className="m-t-l-tabs align-items-center">
                <Link to='/'>
                    <span className="m-t-l-span mr-0">Home</span>
                    </Link>
                    {Headings.map((element: any, index: number) => {
                        return  <>{element && element.name ?<span key={index} className="text-white inline-flex align-items-center ml-2 mt-0 gap-2 "><span><SvgIcon name="rightArrow" size={16} style={{padding:0, marginTop:'6px'}} /></span> {element.name}</span> : ''}</>
                    })}

                </div>
        );
};

export default Breadcrumb;
